import { render, staticRenderFns } from "./Micropoint.vue?vue&type=template&id=af8096d8&scoped=true"
import script from "./Micropoint.vue?vue&type=script&lang=js"
export * from "./Micropoint.vue?vue&type=script&lang=js"
import style0 from "./Micropoint.vue?vue&type=style&index=0&id=af8096d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8096d8",
  null
  
)

export default component.exports